module.exports = __webpack_public_path__ + "static/media/Tooltip.8a45903b.svg";